export default "__VITE_ASSET__eac8f6d9__"